import React, { Component } from 'react';
import { Modal, Transfer, Spin, message } from 'antd';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

class FoldSet extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        targetKeys: [],
    }

    loadData = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.common.queryUserDisplayDefineByType, {
            type: 'CASH_REQ_MULTI_CONTRACT'
        }).then(res => {
            const data = res.CASH_REQ_MULTI_CONTRACT || [];
            const targetKeys = [];
            data.forEach(i => {
                const { isShow, isDefault, userCustomDisplayDefineId } = i;
                if (isShow == 1) {
                    targetKeys.push(userCustomDisplayDefineId);
                }
                i.disabled = isDefault == 1;
                i.key = userCustomDisplayDefineId;
            });
            this.setState({
                data,
                targetKeys,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    show = () => {
        this.setState({ visible: true }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (nextTargetKeys, direction, moveKeys) => {
        this.setState({ targetKeys: nextTargetKeys });

        console.log('targetKeys: ', nextTargetKeys);
        console.log('direction: ', direction);
        console.log('moveKeys: ', moveKeys);
    }

    submit = () => {
        const { data, targetKeys } = this.state;
        if (targetKeys.length > 11) {
            message.warning('折叠后最多可显示11个字段!');
            return;
        }
        const params = {};
        data.forEach((item, index) => {
            const { key, displayType } = item;
            params[`customDisplayDefines[${index}].userCustomDisplayDefineId`] = key;
            params[`customDisplayDefines[${index}].isShow`] = targetKeys.includes(key) ? 1 : 0;
            params[`customDisplayDefines[${index}].displayType`] = displayType;
        });

        this.setState({ loading: true });
        Fetch.post(API_URL.common.setUserDisplayDefineValue, {
            ...params,
            type: 'CASH_REQ_MULTI_CONTRACT'
        }).then(res => {
            message.success(res.success);
            this.setState({ loading: false }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    render() {
        const { visible, loading, data, targetKeys } = this.state;
        const sortTargetKeys = [...targetKeys].sort();
        return (
            <Modal
                title="合同折叠设置"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                confirmLoading={loading}
                maskClosable={false}
                width="680px"
            >
                <Spin spinning={loading}>
                    <Transfer
                        dataSource={data}
                        titles={['折叠后不显示字段', '折叠后显示字段(最多可显示11个字段)']}
                        listStyle={{width: 300, height: 320}}
                        targetKeys={sortTargetKeys}
                        onChange={this.handleChange}
                        onSelectChange={this.handleSelectChange}
                        render={item => item.title}
                    />
                </Spin>
            </Modal>
        );
    }
}

export default FoldSet;


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/components/FoldSet.js